import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { InboxTransferService } from '../inbox-transfer.service';
@Component({
  selector: 'app-inbox-transfer',
  templateUrl: './inbox-transfer.component.html',
  styleUrls: ['./inbox-transfer.component.scss'],
  standalone: false,
})
export class InboxTransferComponent implements OnInit {
  inboxClinicControl = new FormControl();
  examClinicControl = new FormControl();
  filteredInboxClinics: Observable<any[]>;
  filteredExamClinics: Observable<any[]>;

  constructor(
    public inboxTransferService: InboxTransferService,
    private loginService: LoginService,
    private router: Router
  ) {
    this.loginService.loginMissing();
  }

  ngOnInit(): void {
    this.filteredInboxClinics = combineLatest([
      this.inboxClinicControl.valueChanges.pipe(startWith('')),
      this.inboxTransferService.availableClinics$,
    ]).pipe(map(([value, clinics]) => this.filterClinics(value, clinics)));

    this.filteredExamClinics = combineLatest([
      this.examClinicControl.valueChanges.pipe(startWith('')),
      this.inboxTransferService.availableClinics$,
    ]).pipe(map(([value, clinics]) => this.filterClinics(value, clinics)));
  }

  filterClinics(value: any, clinics: any[]): any[] {
    if (!value || typeof value !== 'string') {
      return clinics;
    }

    const filterValue = value.toLowerCase();
    return clinics.filter(
      (clinic) =>
        clinic.ClinicTitle.toLowerCase().includes(filterValue) ||
        clinic.GID.toString().includes(filterValue)
    );
  }

  displayClinic(clinic: any): string {
    return clinic ? `${clinic.GID} - ${clinic.ClinicTitle}` : '';
  }

  onInboxClinicSelected(clinic: any): void {
    if (clinic) {
      this.inboxTransferService.inboxForm.patchValue({ inboxClinic: clinic });
      this.inboxTransferService.onClinicSelect();
    }
  }

  onExamClinicSelected(clinic: any): void {
    if (clinic) {
      this.inboxTransferService.inboxForm.patchValue({ examClinic: clinic });
    }
  }

  togglePopup() {
    this.inboxTransferService.toggleSuccessMessage =
      !this.inboxTransferService.toggleSuccessMessage;
  }

  exit() {
    this.router.navigateByUrl('/patsearch');
  }
}
